var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"head"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"right"},[_vm._t("head-right")],2)]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }